import api from './api';

export interface GeneralWorkCategory {
  id: number;
  name: string;
  description?: string;
  isSystemDefault?: boolean;
}

export const generalWorkCategoryService = {
  // Obtener todos los rubros generales
  async getAllGeneralWorkCategories(): Promise<GeneralWorkCategory[]> {
    const response = await api.get<GeneralWorkCategory[]>(
      'general-work-categories',
    );
    return response.data;
  },

  // Crear un nuevo rubro general
  async createGeneralWorkCategory(
    name: string,
    description: string,
  ): Promise<GeneralWorkCategory> {
    const response = await api.post<GeneralWorkCategory>(
      'general-work-categories',
      { name, description },
    );
    return response.data;
  },

  // Actualizar rubro general
  async updateGeneralWorkCategory(
    id: number,
    name: string,
    description: string,
  ): Promise<GeneralWorkCategory> {
    const response = await api.put<GeneralWorkCategory>(
      `general-work-categories/${id}`,
      { name, description },
    );
    return response.data;
  },

  // Eliminar rubro general
  async deleteGeneralWorkCategory(id: number): Promise<void> {
    await api.delete(`general-work-categories/${id}`);
  },
};

export default generalWorkCategoryService;
